<app-material-list [showTitle]="false"
                   [showCtxMenu]="true"
                   [showTooltipWarnings]="true"
                   data-cy="confirm-send-material-list"
                   [materials]="stepModel.data"
                   [maxNumberOfMaterials]="maxNumberOfMaterials">
</app-material-list>
